import { Grid } from '@mui/material';
import { DetailImage } from '../menu-modal.styles';

const NutritionalInfo = ({ extendedAttributes }) => {
  if (extendedAttributes && Object.entries(extendedAttributes).length > 0)
    return (
      <Grid container justifyContent="center">
        {Object.entries(extendedAttributes).map((image, index) => {
          if (image[0] === 'nutritional_info') return null;
          return (
            <Grid key={`${image[0]}-${index}`} item xs>
              <DetailImage src={image[1]} alt="" />
            </Grid>
          );
        })}
      </Grid>
    );

  return null;
};

export default NutritionalInfo;
